import Axios from "axios"
import Qs from "qs"
import Vue from "vue"

import store from "./store"
import _ from "lodash"
import $i18n from "./i18n"

export default {
  getToken() {
    return store.getters.token
  },
  getBaseUrl() {
    return Vue.config.API_URL
  },
  requestConfig() {
    return {
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
        "Accept-Language": $i18n.locale + "-es",
      },
      paramsSerializer: function(params) {
        return Qs.stringify(params, {
          arrayFormat: "repeat",
        })
      },
      responseType: "json",
    }
  },
  _prepare(config, base = "api/", rawUrl = false) {
    if (!rawUrl) config.url = `${this.getBaseUrl()}${base}${config.url}`

    if (this.getToken()) {
      config.headers = Object.assign(config.headers || {}, {
        Authorization: "Token " + this.getToken(),
      })
    }

    config.params = _.chain(config)
      .get("params", {})
      .omitBy(_.isEmpty)
      .value()

    return Object.assign(this.requestConfig(), config)
  },
  _request(config, base) {
    config = this._prepare(config, base)
    return Axios(config)
      .then(response => {
        return response
      })
      .catch(error => {
        if (!error.response) {
          store.commit("error", $i18n.t("errors.unexpected_disconnection"))
        } else if (_.includes([500, 404], error.response.status)) {
          store.commit("error", $i18n.t("errors.unexpected_error"))
        } else if (_.includes([401], error.response.status)) {
          store.dispatch("logOut")
        } else {
          throw error
        }
      })
  },
  _rawGet(url) {
    const config = this._prepare({ method: "GET", url: url }, "", true)
    return Axios(config)
  },
  _get(url) {
    return this._request({
      method: "GET",
      url: url,
    })
  },
  _post(url, data = {}) {
    return this._request({
      data: data,
      method: "POST",
      url: url,
    })
  },
  authenticate(vatNumber, password) {
    return this._request({
      data: {
        vat_number: vatNumber,
        password: password,
      },
      method: "POST",
      url: "web-token-auth/",
    })
  },
  getDownloadToken() {
    return this._post("download-token/")
  },
  getParcels(pageSize = 15) {
    return this._get(`bikenta/service-request-parcels/?page_size=${pageSize}`)
  },
  getParcel(id) {
    return this._get(`bikenta/service-request-parcels/${id}/`)
  },
  getParcelTracing(id) {
    return this._get(`bikenta/service-request-parcels/${id}/tracing/`)
  },
  getNotification(id) {
    return this._get(`bikenta/notifications/${id}`)
  },
  getUnreadNotifications() {
    return this._get("bikenta/notifications/?read_status=unread")
  },
  setNotificationAsRead(id) {
    return this._post(`bikenta/notifications/${id}/mark_as_read/`)
  },
  getPerson() {
    return this._get("bikenta/person/")
  },
  getAttachments(sourceCertifiedParcelId = 0) {
    return this._get(
      `bikenta/attachments/?source_certified_parcel_id=${sourceCertifiedParcelId}`
    )
  },
  requestPasswordReset(vatNumber) {
    return this._post("bikenta/password-reset/", { vat_number: vatNumber })
  },
  setNewPassword(token, password, passwordRepeat) {
    return this._post("bikenta/new-password/", {
      token: token,
      password: password,
      password_repeat: passwordRepeat,
    })
  },
  getAffectations(parcelId) {
    return this._get(`bikenta/service-request-parcels/${parcelId}/affectations`)
  },

  getC02Global() {
    return this._get("bikenta/manager-co2-records/")
  },

  getEnquiry(enquiryId) {
    return this._get(`bikenta/enquiries/${enquiryId}`)
  },

  getIncidence(indicenceId) {
    return this._get(`bikenta/incidences/${indicenceId}`)
  },

  createEnquiry(incidenceId, description) {
    return this._post("bikenta/enquiry-add/", {
      incidence: incidenceId,
      message: description,
    })
  },

  createEnquiryComment(enquiryId, description) {
    return this._post(`bikenta/enquiries/${enquiryId}/add_comment/`, {
      description: description,
    })
  }
}
